import { useEffect, useState } from "react";
import ComprehensiveFooter from "../../../MicrospecDynamicUI/Pages/SectionsMapper/Footer/ComprehensiveFooter";
import { useMicrospecFlowModulesContext } from "../../Contexts/MicrospecFlowModulesProvider";
import { useMicrospecThemeLanguageContext } from "../../../MicrospecDynamicUI/Themes";
const MicrospecFlowCommonFooter = () => {
    const { localizationProvider } = useMicrospecThemeLanguageContext();
    const modulesTitle = localizationProvider?.translateByType({
        type: "Localized",
        text: "common.modules"
    });
    const { modules, modulesRetrieved } = useMicrospecFlowModulesContext();
    const [mappedModules, setMappedModules] = useState<any[]>([]);

    useEffect(() => {
        if (modulesRetrieved && modules.length > 0) {
            const mapped = modules.map(module => ({
                label: module.name,
                href: module.link,
            }));
            const footerLinks = [
                {
                    title: modulesTitle,
                    links: mapped,
                }
            ]
            setMappedModules(footerLinks);
        }
    }, [modules, modulesRetrieved, modulesTitle]);
    return <ComprehensiveFooter spec={{
        navigationLinks: mappedModules,
    }} />;
}

export default MicrospecFlowCommonFooter;